import { FC } from 'react';
import type { HeaderProps } from 'src/common/components/Header';
import Header from 'src/common/components/Header';
import { useSearchHeroVisibilityContext } from 'src/common/components/Search/SearchHeroVisibilityProvider';

const HeaderSticky: FC<HeaderProps> = (props) => {
  const { heroInView } = useSearchHeroVisibilityContext();

  return (
    <Header
      {...props}
      withSearch={heroInView === false || props.withSearch}
    />
  );
};
export default HeaderSticky;
